function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { InteractionRequiredAuthError, InteractionStatus, InteractionType } from '@azure/msal-browser';
import { useMsal, useMsalAuthentication } from '@azure/msal-react';
import { logger } from '@src/logger';
import { updateUser } from '@shared/actions/thunkActions';
import { createAuthenticatedUser, createGuestUser } from '@shared/msal/user';
import { Constants } from '@shared/utils/constants';
import { getExtraScopesToConsent } from '@shared/msal/scopes';
import { fetchAccessTokens } from '@shared/msal/tokens';
import { stringifyError } from '@shared/utils/errorUtils';
import { getSilentRedirectUri } from '@shared/msal/config';
import { getLocalStorageItem, saveLocalStorageItem } from '@shared/utils/browserStorageUtils';
const SilentClientLogin = ()=>{
    const dispatch = useDispatch();
    const [hasActiveUser, setHasActiveUser] = useState(false);
    const ssoStartTime = useRef(null);
    const { error, result } = useMsalAuthentication(InteractionType.Silent, {
        redirectUri: getSilentRedirectUri(),
        extraScopesToConsent: getExtraScopesToConsent(),
        loginHint: getLocalStorageItem(Constants.LocalStorage.LoginHint)
    });
    const { accounts, instance, inProgress } = useMsal();
    const activeAccount = accounts === null || accounts === void 0 ? void 0 : accounts[0];
    useEffect(()=>{
        const setActiveUser = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function*() {
                instance.setActiveAccount(activeAccount);
                saveLocalStorageItem(Constants.LocalStorage.LoginHint, activeAccount.idTokenClaims.login_hint);
                const accessTokens = yield fetchAccessTokens({
                    resources: [
                        'spza',
                        'arm',
                        'graph',
                        'commerce',
                        'jarvis',
                        'marketplaceLeads',
                        'pifd',
                        'agreement'
                    ]
                });
                const user = createAuthenticatedUser({
                    accessTokens,
                    account: activeAccount,
                    ssoStartTime: ssoStartTime.current
                });
                dispatch(updateUser({
                    userDetails: user
                }));
            });
            return function setActiveUser() {
                return _ref.apply(this, arguments);
            };
        }();
        if (activeAccount && !hasActiveUser && inProgress === InteractionStatus.None) {
            setHasActiveUser(true);
            setActiveUser();
        }
    }, [
        activeAccount,
        hasActiveUser,
        inProgress,
        dispatch,
        instance
    ]);
    useEffect(()=>{
        if (error) {
            dispatch(updateUser({
                userDetails: createGuestUser()
            }));
            const stringifiedError = stringifyError(error);
            if (error instanceof InteractionRequiredAuthError) {
                logger.warning(stringifiedError, {
                    action: Constants.Telemetry.Action.Login,
                    actionModifier: Constants.Telemetry.ActionModifier.SSO_LOGIN_ERROR
                });
            } else {
                logger.error(stringifiedError, {
                    action: Constants.Telemetry.Action.Login,
                    actionModifier: Constants.Telemetry.ActionModifier.SSO_LOGIN_ERROR,
                    error
                });
            }
        }
    }, [
        error
    ]);
    useEffect(()=>{
        if (result) {
            logger.info(JSON.stringify({
                fromCache: result.fromCache
            }), {
                action: Constants.Telemetry.Action.Login,
                actionModifier: Constants.Telemetry.ActionModifier.SSO_LOGIN_SUCCEEDED
            });
        }
    }, [
        result
    ]);
    useEffect(()=>{
        ssoStartTime.current = Date.now();
        logger.info('', {
            action: Constants.Telemetry.Action.Login,
            actionModifier: Constants.Telemetry.ActionModifier.Start
        });
    }, []);
    return /*#__PURE__*/ _jsx(_Fragment, {});
};
export default SilentClientLogin;
